<template>
  <!-- 关联项目列表 -->
  <div>
    <div class="header">
      <i class="icon-fanhui iconfont icon back"
         @click="back"></i>
      <div>关联项目</div>
    </div>
    <div class="relatedPro">
      <div class="relatedPro_top">
        <span v-for="(item,index) in titleList"
              :key="index"
              :class="{active:currentTab==index}"
              @click="getTab(index)">{{item.name}}</span>
      </div>
      <div class="relatedPro_bottom">
        <!-- 默认关联 -->
        <div class="associatedproject"
             v-if="currentTab==0">
          <mt-loadmore :top-method="loadTop"
                       :bottom-method="loadBottom"
                       :bottom-all-loaded="allLoaded"
                       :auto-fill="false"
                       ref="loadmore">
            <ul v-if="relatedList.length>0">
              <li class="projectitem"
                  v-for="(item,index) in relatedList"
                  :key="index">
                <div class="pro-left">
                  <img v-if="item.cover_picture"
                       :src="getAvatar(item.cover_picture)"
                       class="proimg" />
                  <img v-else
                       src="../../../assets/img/user-avatar.png"
                       class="proimg"
                       style="width:1.55rem;height:1.55rem;" />
                </div>
                <div class="pro-right">
                  <div class="pro-name">
                    <div class='pro-title'>{{item.name}}</div>
                  </div>
                  <div class="proinfo">
                    <span>人气：<span class="c_222">{{item.popularity_num}}</span></span>
                    <span>注册用户数：<span class="c_222">{{item.register_num}}</span></span>
                  </div>
                </div>
              </li>
            </ul>
          </mt-loadmore>
          <nodata v-if="relatedList.length<=0"></nodata>
        </div>
        <!-- 默认关联 -->
        <!-- 我的关注 -->
        <div class="associatedproject"
             style="padding-bottom:2rem;"
             v-if="currentTab==1">
          <mt-loadmore :top-method="loadTop"
                       :bottom-method="loadBottom"
                       :bottom-all-loaded="allLoaded"
                       :auto-fill="false"
                       ref="loadmore">
            <ul style="overflow:scroll;height:15rem"
                v-if="relatedList.length>0">
              <li class="projectitem"
                  v-for="(item,index) in relatedList"
                  :key="index">
                <div class="pro-left">
                  <img v-if="item.cover_picture"
                       :src="getAvatar(item.cover_picture)"
                       class="proimg" />
                  <img v-else
                       src="../../../assets/img/user-avatar.png"
                       class="proimg"
                       style="width:1.55rem;height:1.55rem;" />
                </div>
                <div class="pro-right">
                  <div class="pro-name">
                    <div class='pro-title'>{{item.name}}</div>
                    <div class="visit"
                         @click="removeRelateBtn(item.project_code)">取消关注</div>
                  </div>
                  <div class="proinfo">
                    <span>人气：<span class="c_222">{{item.popularity_num}}</span></span>
                    <span>注册用户数：<span class="c_222">{{item.register_num}}</span></span>
                  </div>
                </div>
              </li>
            </ul>
          </mt-loadmore>
          <div style="position:fixed;bottiom:0;background:#fff;">
            <div class="addfllowpro"
                 @click="addFllowPro">添加关注项目</div>
          </div>
          <nodata v-if="relatedList.length<=0"></nodata>
        </div>
        <!-- 我的关注 -->
      </div>
    </div>

  </div>
  <!-- 关联项目列表 -->
</template>
<script>
  import nodata from '../../public/nodata.vue'
  import { Popup, Picker, Loadmore, InfiniteScroll, Indicator, MessageBox } from 'mint-ui';
  import Vue from 'vue';
  Vue.component(Popup.name, Popup);
  Vue.component(Picker.name, Picker);
  Vue.component(Loadmore.name, Loadmore);
  Vue.use(InfiniteScroll);
  Vue.use(Loadmore);
  export default {
    components: {
      nodata
    },
    data () {
      return {
        currentTab: '0',
        titleList: [
          { id: '0', name: '默认关联' },
          { id: '1', name: '我的关注' }
        ],
        relatedPro: {
          type: '1',
        },
        relatedList: [],//默认关联数组
        pagiNation: {
          total: 0,
          last_page: '',//最后一页
          current_page: '',//当前页
        },
        allLoaded: false,
      }
    },
    created () {
      if (this.$route.query.type) {//判断是否是选择了项目之后跳转回来的
        this.currentTab = '1'
        this.relatedPro.type = '2'
      } else {
        this.currentTab = '0'
        this.relatedPro.type = '1'
      }
      // this.getListData()
      let that=this
      setTimeout(function(){
     that.getListData()
      },800)

    },
    methods: {
      back () {//返回
        this.$router.push({ name: 'my' })
      },
      getTab (index) {
        this.currentTab = index
        this.relatedPro.type = index + 1
        this.allLoaded = false//控制下拉刷新
        this.getListData()
      },
      getAvatar (src) {//获取头像
        return `${src}`
      },
      getListData () {//获取列表数据
        let page = 1
        this.$http.getRelationPro(this.relatedPro, page).then(res => {
          this.relatedList = res.data.list//  获得数组列表
          this.pagiNation.current_page = res.data.pagination.current_page//当前页数
          this.pagiNation.last_page = res.data.pagination.last_page// 最后一页
        })
      },
      getList () {//获取更多数据
        Indicator.open({
          text: '加载中...',
          spinnerType: 'fading-circle'
        })
        if (this.pagiNation.current_page < this.pagiNation.last_page) {
          setTimeout(() => {
            this.$http.getRelationPro(this.relatedPro, this.pagiNation.current_page + 1).then(res => {
              this.relatedList = this.relatedList.concat(res.data.list) //列表数据
              this.pagiNation.current_page = res.data.pagination.current_page//当前页面
              this.pagiNation.last_page = res.data.pagination.last_page//最后一页
              Indicator.close()
              if (this.pagiNation.current_page == this.pagiNation.last_page) {
                this.allLoaded = true
                MessageBox('提示', "没有更多数据了")
              }
            })
          }, 1000)
        }
        if (this.pagiNation.current_page == this.pagiNation.last_page) {
          MessageBox('提示', "没有更多数据了")
        }
      },
      addFllowPro () {//添加关注项目
        this.$router.push({ name: 'relatedprolist' })
      },
      loadTop () {//上拉刷新
      },
      loadBottom () {//下拉加载更多
        if (this.pagiNation.current_page < this.pagiNation.last_page)
          this.getList()//刷新数据
        this.$refs.loadmore.onBottomLoaded();
      },
      removeRelateBtn (code) {//取消关注
        this.allLoaded = false//控制下拉刷新
        MessageBox.confirm(`您确认取消对此项目的关注?`).then(action => {
          this.$http.removeRelation(code).then(res => {
            if (res.errCode == 0) {
              MessageBox('提示', '取消关注成功')
              this.getListData()
            } else {
              MessageBox('提示', res.errMsg)
            }
          })

        }, cancel => {
          //   MessageBox('提示', '取消')
        });


      },
    }
  }
</script>
<style scoped>
  .header {
    width: 100%;
    text-align: center;
    font-size: 0.375rem;
    background-color: #fff;
    height: 1.04375rem;
    line-height: 1.09375rem;
    position: fixed;
    top: 0;
    z-index: 99;
  }
  .back {
    position: absolute;
    left: 0.1rem;
  }
  .relatedPro {
    background: #f7f7f7;
    margin-top: 1.04375rem;
    background: #fff;
    padding: 0 0.426rem;
  }
  .relatedPro_top > span {
    display: inline-block;
    width: 20%;
    text-align: center;
    margin: 0 15%;
    padding: 1% 0;
    font-size: 14px;
  }
  .active {
    /* color: #5483d2; */
    border-bottom: 2px solid #5483d2;
  }
  .projectitem {
    overflow: hidden;
    border-top: 1px solid #ccc;
    padding-bottom: 0.1rem;
  }
  .pro-left {
    float: left;
    position: relative;
    margin-top: 1%;
  }
  .proimg {
    width: 1.4rem;
    height: 1.4rem;
    position: relative;
    top: 50%;
    margin-top: 0.3rem;
    border-radius: 50%;
  }
  .pro-right {
    width: 75%;
    margin: 0.4rem 0 0 0.3rem;
    float: left;
    font-size: 16px;
  }
  .pro-name {
    overflow: hidden;
    width: 100%;
  }
  .pro-title {
    float: left;
    font-size: 0.35rem;
    width: 4.8rem;
    white-space: normal;
    word-break: break-all;
  }
  .proinfo {
    margin-bottom: 0.1rem;
    margin-top: 0.1rem;
    font-size: 13px;
    color: #9b9b9b;
    display: flex;
  }
  .proinfo > span {
    display: inline-block;
    flex: 1;
  }
  .c_222 {
    color: #222222;
    font-size: 16px;
  }
  .visit {
    float: right;
    font-size: 0.36rem;
    font-weight: 300;
    color: #2e6deb;
    background: #dfeaff;
    border-radius: 0.3rem;
    padding: 0 0.15rem;
  }
  .addfllowpro {
    position: fixed;
    bottom: 0.4rem;
    border-radius: 0.2rem;
    width: 90%;
    height: 1.1rem;
    line-height: 1.1rem;
    text-align: center;
    color: #ffffff;
    background: #95afeb;
    z-index: 500;
    font-size: 14px;
  }
</style>





// WEBPACK FOOTER //
// src/components/drillPage/relatedProject/Index.vue